import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategorySelect = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setDropdownOpen(false);
  };

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20flat%20lay%20photography%20of%20neutral%20toned%20fashion%20items%20including%20linen%20fabric%2C%20leather%20accessories%2C%20and%20textile%20swatches%20arranged%20organically%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20lighting%20from%20above%2C%20elegant%20editorial%20product%20photography%2C%20gentle%20shadows%2C%20warm%20beige%20aesthetic%2C%20no%20logos&width=1920&height=1080&seq=hero-main-unique-2026b&orientation=landscape"
          alt="AllChinaBuySpreadsheet product sourcing background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-32 md:py-40">
        <div className="max-w-4xl">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            AllChinaBuy<br />
            Spreadsheet<br />
            System 2026
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-xl mb-10 leading-relaxed">
            Find winning products, compare suppliers, and explore trending China goods in one powerful spreadsheet system.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4 mb-8">
            <div ref={dropdownRef} className="relative w-full sm:w-64">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-5 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white text-sm font-medium cursor-pointer hover:bg-white/15 transition-all duration-300 whitespace-nowrap"
              >
                <span>Browse Categories</span>
                <i className={`${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} ml-2 transition-transform duration-200`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-full bg-background-50 rounded-lg border border-background-200 shadow-lg overflow-hidden z-50 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <button
                      key={cat.name}
                      onClick={() => handleCategorySelect(cat.url)}
                      className="w-full flex items-center gap-3 px-4 py-3 text-left text-foreground-800 text-sm hover:bg-background-100 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-base text-secondary-500`}></i>
                      {cat.name}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-white text-foreground-950 rounded-lg text-sm font-semibold hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                allchinabuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors duration-300 cursor-pointer"
          >
            Go to Main Platform
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#value" className="text-white/60 hover:text-white transition-colors duration-300 cursor-pointer">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}